import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { OutboundDocumentAPI } from '../api/outboundDocument.ts';

export const OUTBOUND_DOCUMENTS_KEY = 'OUTBOUND_DOCUMENTS_KEY';

const useReadOneById = (
  outboundDocumentId: string | number,
  options: Partial<
    UseQueryOptions<OutboundDocumentAPI.Response.ReadOneById | null>
  >
) =>
  useQuery({
    queryKey: [
      OUTBOUND_DOCUMENTS_KEY,
      endpoints.outboundDocument.read.one.by.id(),
      outboundDocumentId,
    ],
    queryFn: () => api.outboundDocument.read.one.by.id(outboundDocumentId),
    ...options,
  });

const useReadManySearch = (
  params: OutboundDocumentAPI.Request.ReadManySearch,
  options?: Partial<
    UseQueryOptions<OutboundDocumentAPI.Response.ReadManySearch[] | null>
  >
) =>
  useQuery({
    queryKey: [
      OUTBOUND_DOCUMENTS_KEY,
      endpoints.outboundDocument.read.many.search(),
      params,
    ],
    queryFn: () => api.outboundDocument.read.many.search(params),
    ...options,
  });

const useDownloadOneById = (
  outboundDocumentId: string | number,
  options?: Partial<UseQueryOptions<any>>
) =>
  useQuery({
    queryKey: [
      OUTBOUND_DOCUMENTS_KEY,
      endpoints.outboundDocument.download.one.by.id(),
      outboundDocumentId,
    ],
    queryFn: () => api.outboundDocument.download.one.by.id(outboundDocumentId),
    ...options,
  });

const outboundDocumentHooks = {
  useReadOneById,
  useReadManySearch,
  useDownloadOneById,
};

export default outboundDocumentHooks;
